// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"35":"e65e2c6e5ffde497854e","161":"d460d31e2af6114cf734","938":"5fca10208aeddffd59a0"}[chunkId] + ".css";
};